import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// HOOKS
import useActions from '@/hooks/useActions';

// STORE
import { AppDetailsActions, OnboardingActions } from '@/store/actions';

// COMPONENTS
import BannerWithApps from '@/components/Banners/BannerWithApps';

function BannerAddApps({ btnProps, ...restProps }) {
  const [t] = useTranslation();

  const [onboardingSetState, appListUpdateAppStatuses] = useActions([
    (state, props) => OnboardingActions.onboardingSetState.action({ state, props }),
    apps => AppDetailsActions.appListUpdateAppStatuses.action({ apps }),
  ]);

  function handleOpenOnboarding() {
    onboardingSetState(true, {
      callback: data => appListUpdateAppStatuses(data.apps),
    });
  }

  return (
    <BannerWithApps
      title={t('homeAuth.banners.onboarding.title')}
      subtitle={t('homeAuth.banners.onboarding.subtitle')}
      btnText={t('buttons.addApps')}
      {...restProps}
      btnProps={{
        onClick: handleOpenOnboarding,
        ...btnProps,
      }}
    />
  );
}
BannerAddApps.defaultProps = {
  btnProps: {},
};

BannerAddApps.propTypes = {
  className: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  subtitle: PropTypes.string,
  btnText: PropTypes.string,
  btnProps: PropTypes.object,
  secondaryBtnText: PropTypes.string,
  secondaryBtnProps: PropTypes.object,
};

export default React.memo(BannerAddApps);
